module.exports = __webpack_public_path__ + "img/info4.52ecf04f.jpeg";